module.exports = __webpack_public_path__ + "img/go-plus.6751a1bd.png";